<div class="container" id="container" #container>
  
  <img src="https://client.punchdigitizing.com/digitizing_api/public/login.png" alt="Logo" class="mobile-screen-logo" />

  <div class="mobile-tabs">
    <button class="tab-button" [class.active]="activeTab === 'login'" (click)="activeTab = 'login'" id="loginTab">
      <svg class="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
        <polyline points="10,17 15,12 10,7"/>
        <line x1="15" y1="12" x2="3" y2="12"/>
      </svg>
      Login
    </button>
    <button class="tab-button" [class.active]="activeTab === 'register'" (click)="activeTab = 'register'" id="registerTab">
      <svg class="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="8.5" cy="7" r="4"/>
        <line x1="20" y1="8" x2="20" y2="14"/>
        <line x1="23" y1="11" x2="17" y2="11"/>
      </svg>
      Register
    </button>
  </div>

  <!-- Updated registration form with enhanced styling -->
  <div class="form-container sign-up-container" [class.active]="activeTab === 'register'">
    <div class="form-scroll-container">
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="register-form">
        <div class="form-header">
          <h1>Create Account</h1>
          <span>Join Punch Digitizing today and start your journey with professional embroidery digitizing</span>
        </div>

        <!-- SUCCESS MESSAGE -->
        <div class="success-message" *ngIf="!submitted && registerForm.pristine && activeTab === 'register'">
          <svg class="success-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22,4 12,14.01 9,11.01"/>
          </svg>
          <span>Ready to create your account? Fill out the form below.</span>
        </div>

        <!-- Form Fields with Enhanced Styling -->
        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            <input class="form-control" type="text" formControlName="name" placeholder="Full Name">
          </div>
          <div class="validation-feedback" *ngIf="(registerForm.get('name')?.touched || submitted) && registerForm.get('name')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('name')?.errors?.required">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Name is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M12 1v6m0 6v6"/>
              <path d="m21 12-6-3-6 3-6-3"/>
            </svg>
            <input class="form-control" type="text" formControlName="user_name" placeholder="Username">
          </div>
          <div class="validation-feedback" *ngIf="(registerForm.get('user_name')?.touched || submitted) && registerForm.get('user_name')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('user_name')?.errors?.required">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Username is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 21h18"/>
              <path d="M5 21V7l8-4v18"/>
              <path d="M19 21V11l-6-4"/>
            </svg>
            <input class="form-control" type="text" formControlName="company_name" placeholder="Company Name">
          </div>
          <div class="validation-feedback" *ngIf="(registerForm.get('company_name')?.touched || submitted) && registerForm.get('company_name')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('company_name')?.errors?.required">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Company Name is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            <input class="form-control" type="text" formControlName="country" placeholder="Country">
          </div>
          <div class="validation-feedback" *ngIf="(registerForm.get('country')?.touched || submitted) && registerForm.get('country')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('country')?.errors?.required">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Country is required
            </div>
          </div>
        </div>

        <!-- SIMPLE PHONE INPUT - Updated with maxlength -->
        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <input 
              class="form-control" 
              type="tel" 
              formControlName="contact_no" 
              placeholder="Enter your phone number with country code"
              title="Enter your phone number with country code"
              maxlength="14">
          </div>
          <!-- Removed phone helper text with examples -->
          
          <!-- FIXED: Only show error if field is actually invalid -->
          <div class="validation-feedback" *ngIf="(registerForm.get('contact_no')?.touched || submitted) && registerForm.get('contact_no')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('contact_no')?.hasError('required')">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Phone number is required
            </div>
            <div class="error-message" *ngIf="registerForm.get('contact_no')?.hasError('minlength')">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Phone number is too short (minimum 10 characters)
            </div>
            <div class="error-message" *ngIf="registerForm.get('contact_no')?.hasError('maxlength')">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Phone number is too long (maximum 14 characters)
            </div>
          </div>
          <!-- SUCCESS FEEDBACK - Made icon smaller -->
          <div class="validation-feedback success-feedback" *ngIf="registerForm.get('contact_no')?.valid && registerForm.get('contact_no')?.value && registerForm.get('contact_no')?.touched">
            <div class="success-message-inline">
              <svg class="success-icon-mini" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              Valid phone number
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="8.5" cy="7" r="4"/>
              <line x1="20" y1="8" x2="20" y2="14"/>
              <line x1="23" y1="11" x2="17" y2="11"/>
            </svg>
            <input class="form-control" type="text" formControlName="referredBy" placeholder="Referred by (optional)">
          </div>
        </div>

        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
            <select class="form-control custom-select" formControlName="currency" id="currency">
              <option value="" disabled selected>Select Currency</option>
              <option value="USD">US Dollar (USD)</option>
              <option value="GBP">British Pound (GBP)</option>
              <option value="CAD">Canadian Dollar (CAD)</option>
              <option value="AUD">Australian Dollar (AUD)</option>
              <option value="EUR">Euro (EUR)</option>
            </select>
          </div>
          <div class="validation-feedback" *ngIf="(registerForm.get('currency')?.touched || submitted) && registerForm.get('currency')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('currency')?.errors?.required">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Please select a currency
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <input class="form-control" type="email" formControlName="email" placeholder="app@yourmail.com">
          </div>
          <div class="validation-feedback" *ngIf="(registerForm.get('email')?.touched || submitted) && registerForm.get('email')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('email')?.errors?.required">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Email is required
            </div>
            <div class="error-message" *ngIf="registerForm.get('email')?.errors?.email">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Please enter a valid email address
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-wrapper password-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <circle cx="12" cy="16" r="1"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <input class="form-control"
                   [type]="showPassword ? 'text' : 'password'"
                   formControlName="password"
                   placeholder="Create a strong password" />
            <button type="button" class="eye-toggle" (click)="togglePasswordVisibility()">
              <svg *ngIf="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
          <div class="validation-feedback" *ngIf="(registerForm.get('password')?.touched || submitted) && registerForm.get('password')?.invalid">
            <div class="error-message" *ngIf="registerForm.get('password')?.errors?.required">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Password is required
            </div>
            <div class="error-message" *ngIf="registerForm.get('password')?.errors?.minlength">
              <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Password must be at least {{registerForm.get('password')?.errors?.minlength?.requiredLength}} characters
            </div>
          </div>
        </div>

        <button class="btn btn-block animated-btn" type="submit" [disabled]="submitted">
          <span *ngIf="!submitted">Create Account</span>
          <span *ngIf="submitted">Creating Account...</span>
          <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12,5 19,12 12,19"/>
          </svg>
        </button>

        <!-- DETAILED VALIDATION SUMMARY -->
        <div class="form-validation-summary" *ngIf="submitted && registerForm.invalid">
          <div class="validation-header">
            <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <strong>Please fix the following errors:</strong>
          </div>
          
          <div class="error-list">
            <div class="error-item" *ngIf="registerForm.get('name')?.invalid && (registerForm.get('name')?.touched || submitted)">
              • Full Name is required
            </div>
            <div class="error-item" *ngIf="registerForm.get('user_name')?.invalid && (registerForm.get('user_name')?.touched || submitted)">
              • Username is required
            </div>
            <div class="error-item" *ngIf="registerForm.get('company_name')?.invalid && (registerForm.get('company_name')?.touched || submitted)">
              • Company Name is required
            </div>
            <div class="error-item" *ngIf="registerForm.get('country')?.invalid && (registerForm.get('country')?.touched || submitted)">
              • Country is required
            </div>
            <div class="error-item" *ngIf="registerForm.get('contact_no')?.invalid && (registerForm.get('contact_no')?.touched || submitted)">
              • Phone number is required (include country code, e.g., +1 555 123 4567)
            </div>
            <div class="error-item" *ngIf="registerForm.get('currency')?.invalid && (registerForm.get('currency')?.touched || submitted)">
              • Please select a currency
            </div>
            <div class="error-item" *ngIf="registerForm.get('email')?.invalid && (registerForm.get('email')?.touched || submitted)">
              • Valid email address is required
            </div>
            <div class="error-item" *ngIf="registerForm.get('password')?.invalid && (registerForm.get('password')?.touched || submitted)">
              • Password must be at least 6 characters long
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
    
  <div class="form-container sign-in-container" [class.active]="activeTab === 'login'">
    <form [formGroup]="loginForm">
      <div class="form-header">
        <h1>Welcome Back</h1>
        <span>Sign in to your account to continue your digitizing journey</span>
      </div>

      <div class="form-group">
        <div class="input-wrapper">
          <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
          <input 
            class="form-control" 
            type="email" 
            required="" 
            placeholder="app@yourmail.com"
            formControlName="email">
        </div>
        <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" class="validation-feedback">
          <div class="error-message" *ngIf="loginForm.get('email')?.errors?.required">
            <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Email is required
          </div>
          <div class="error-message" *ngIf="loginForm.get('email')?.errors?.email">
            <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Invalid email format
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="input-wrapper password-wrapper">
          <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <circle cx="12" cy="16" r="1"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <input 
            class="form-control" 
            [type]="showPassword ? 'text' : 'password'" 
            formControlName="password" 
            placeholder="Enter your password" 
            required />
          <button type="button" class="eye-toggle" (click)="togglePasswordVisibility()">
            <svg *ngIf="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
            <svg *ngIf="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
              <line x1="1" y1="1" x2="23" y2="23"/>
            </svg>
          </button>
        </div>
        <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" class="validation-feedback">
          <div class="error-message" *ngIf="loginForm.get('password')?.errors?.required">
            <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Password is required
          </div>
          <div class="error-message" *ngIf="loginForm.get('password')?.errors?.minlength">
            <svg class="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Password must be at least 6 characters long
          </div>
        </div>
      </div>

      <div class="forgot-password">
        <a routerLink="/auth/forget-password">
          <svg class="link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 1v6m0 6v6"/>
            <path d="m21 12-6-3-6 3-6-3"/>
          </svg>
          Forgot Password?
        </a>
      </div>

      <button
        class="btn btn-block animated-btn"
        [disabled]="!loginForm.valid"
        (click)="login()"
        type="button"
      >
        <span>Sign In</span>
        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
          <polyline points="10,17 15,12 10,7"/>
          <line x1="15" y1="12" x2="3" y2="12"/>
        </svg>
      </button>
    </form>
  </div>
    
  <div class="overlay-container">
    <div class="overlay">
      <div class="overlay-panel overlay-left">
        <div class="overlay-content">
          <img src="https://client.punchdigitizing.com/digitizing_api/public/login.png" alt="Logo" class="overlay-logo">
          <h1>New Here?</h1>
          <p>Join thousands of satisfied customers and start your digitizing journey with us today</p>
          
          <div class="features-list">
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>Professional embroidery digitizing</span>
            </div>
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>24/7 customer support</span>
            </div>
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>Fast turnaround times</span>
            </div>
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>High-quality results guaranteed</span>
            </div>
          </div>
          
          <button class="ghost btn-block animated-btn" id="signIn">
            <span>Sign In</span>
            <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12,5 19,12 12,19"/>
            </svg>
          </button>
        </div>
      </div>
      
      <div class="overlay-panel overlay-right">
        <div class="overlay-content">
          <img src="https://client.punchdigitizing.com/digitizing_api/public/login.png" alt="Logo" class="overlay-logo">
          <h1>Welcome Back!</h1>
          <p>Sign in to access your account and continue your digitizing projects</p>
          
          <div class="features-list">
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>Access your project history</span>
            </div>
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>Track order progress</span>
            </div>
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>Manage your account settings</span>
            </div>
            <div class="feature-item">
              <svg class="feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <span>Download completed files</span>
            </div>
          </div>
          
          <button class="ghost btn-block animated-btn" id="signUp">
            <span>Sign Up</span>
            <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12,5 19,12 12,19"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
